<template>
  <v-menu open-on-hover offset-y>
    <template v-slot:activator="{ on, value }">
      <a
        class="navigation-item inner-link my-0"
        style="z-index: 1"
        v-on="on"
        @click="handleClick($event, on)"
      >
        {{ $t(text) }}
        <v-icon v-if="showIcon" color="primary">{{
          value ? "keyboard_arrow_up" : "keyboard_arrow_down"
        }}</v-icon>
      </a>
    </template>
    <SubNavigationList :items="items" :to="to" />
  </v-menu>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import SubNavigationList from "./SubNavigationList.vue";

@Component({ components: { SubNavigationList } })
export default class extends Vue {
  @Prop(String) to!: string;
  @Prop(String) text!: string;
  @Prop(Array) items!: [];
  @Prop(Boolean) showIcon!: boolean;

  handleClick(
    e: MouseEvent & KeyboardEvent,
    on: Record<string, (e: MouseEvent & KeyboardEvent) => void> = {}
  ) {
    e.preventDefault();
    on.click(e);
  }
}
</script>
